import React from 'react';
import Placeholder from 'react-bootstrap/Placeholder';
import { setStorageWithExpiry, getStorageWithExpiry, setStorage, getStorage } from '../../api/index'

const MESES = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

const mesLetraDesdeFecha = (fecha) => {
    if (!fecha) return '';
    const parts = String(fecha).split('-');
    if (parts.length < 2) return '';
    const mes = parseInt(parts[1], 10);
    if (Number.isNaN(mes) || mes < 1 || mes > 12) return '';
    return MESES[mes - 1];
};

const replaceVariables = (htmlString, planInfo) => {

    if (!planInfo) {
        planInfo = {};
        planInfo.appaterno = 'empty';
        planInfo.apmaterno = 'empty';
        planInfo.nombre = 'empty';
        planInfo.descrcclinscripcion = 'empty';
        planInfo.costoinscripcion = 'empty';
        planInfo.costopaquete = 'empty';
        planInfo.descrgrado = 'empty';
        planInfo.descrprograma = 'empty';
        planInfo.descrcclinscripcionletra = 'empty';
        planInfo.cclinscripcionannio = 'empty';
        planInfo.fechainiciocclinscripcionmesletra = 'empty';
        planInfo.fechafincclinscripcionmesletra = 'empty';
    } else {
        planInfo = {
            ...planInfo,
            fechainiciocclinscripcionmesletra: mesLetraDesdeFecha(planInfo.fechainiciocclinscripcion),
            fechafincclinscripcionmesletra: mesLetraDesdeFecha(planInfo.fechafincclinscripcion),
        };
    }

    htmlString = htmlString
        .replaceAll('@costoinscripcion@', `$ ${planInfo.costoinscripcion.toLocaleString(undefined, { minimumFractionDigits: 2 })} MXN`)
        .replaceAll('@costopaquete@', `$ ${planInfo.costopaquete.toLocaleString(undefined, { minimumFractionDigits: 2 })} MXN`);

    Object.keys(planInfo).forEach(function (key, index) {
        htmlString = htmlString.replaceAll(`@${key}@`, planInfo[key])
    });

    return htmlString;
};

function useAsync(asyncFn, onSuccess) {
    React.useEffect(() => {
        let isActive = true;
        asyncFn().then(data => {
            if (isActive) onSuccess(data)
        });
        return () => {
            isActive = false;
        };
    }, [asyncFn, onSuccess]);
}

export default function Plantilla({ id, planInfo }) {
    const [htmlContent, setHtmlContent] = React.useState('');

    const getPlantillaHtml = () => {
        var plantillaValue = getStorageWithExpiry(`plantilla_${id}`);
        if (!plantillaValue) {
            return fetch(`plantillas/${id}.html`)
                .then((response) => {
                    var data = response.text();
                    return data;
                }).then(htmlString => {
                    setStorageWithExpiry(`plantilla_${id}`, htmlString);
                    return htmlString;
                })
        } else {
            const promise = new Promise((resolve) => {
                resolve(plantillaValue);
            });

            return promise;
        }
    };

    const handleResponse = (htmlString) => {
        setHtmlContent(replaceVariables(htmlString, planInfo));
    }

    useAsync(getPlantillaHtml, handleResponse);

    if (!htmlContent) {
        return <>
            <Placeholder xs={6} />
            <Placeholder className="w-75" />
            <Placeholder style={{ width: '25%' }} />
        </>;
    }

    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

//export default Plantilla;


